import React from "react";
import { Typography } from "@mui/material";

import "./error.css";

export default function NotFoundPage() {
  return (
    <div
      className="admin-error"
    >
      <Typography className="code">
        404
      </Typography>
      <Typography className="title">
        Page Not Found
      </Typography>
      <Typography className="description">
        The page you are trying to access cannot be found. It may have been moved, deleted, or the link might be incorrect.
      </Typography>
    </div>
  );
}
